import api from '@api/index'
import { PersonalizedGroup } from '@models/PersonalizedGroup'
import { PersistentDataService } from '@services/PersistentDataService'
import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const usePersonalizedGroupStore = defineStore(
  'personalizedGroupStore',
  () => {
    const personalizedGroupSelected = ref<PersonalizedGroup | undefined>()
    const personalizedGroups = ref<PersonalizedGroup[]>([])
    const isPersonalizedManagerOpen = ref(false)

    watch(
      () => personalizedGroupSelected.value,
      (value: PersonalizedGroup | undefined) => {
        PersistentDataService.saveOptions('personalizedGroupSelected', value)
      }
    )

    const fetchPersonalizedGroups = async () => {
      const response = (await api.personalizedGroup.getPersonalizedGroups())
        .data
      return (personalizedGroups.value = response.map(
        (personalizedGroupDTO) => {
          return PersonalizedGroup.fromDTO(personalizedGroupDTO)
        }
      ))
    }

    const SET_PERSISTENT_DATA = () => {
      const persistentSelected = PersistentDataService.getOptions(
        'personalizedGroupSelected'
      )
      if (
        persistentSelected &&
        personalizedGroups.value.some(
          (personalizedGroup) => personalizedGroup.id === persistentSelected.id
        )
      ) {
        personalizedGroupSelected.value = persistentSelected
      } else {
        personalizedGroupSelected.value = undefined
      }
    }

    return {
      personalizedGroupSelected,
      personalizedGroups,
      fetchPersonalizedGroups,
      SET_PERSISTENT_DATA,
      isPersonalizedManagerOpen
    }
  }
)
